import axios from "axios";
import {getField, updateField} from "vuex-map-fields";
import i18n from '@/i18n';
import Vue from "vue";

export default {
  namespaced: true,
  state: {
    fetched: false,
    savingInProgress: false,
    cartCheckLoading: false,
    defaultCartCounter: null,
    defaultCartId: null,
    cartType: 'parts',
    cartIsLoading: false,
    carts: [],
    calculationIsLoading: true,
    calculations: [],
    calculation: {
      car: null,
      customer: null,
      items: []
    }
  },
  getters: {
    getField, //vuex-map-fields
    defaultCart: state => {
      for (let i in state.carts) {
        if (state.carts[i].id == state.defaultCartId) {
          return state.carts[i];
        }
      }
    }
  },
  mutations: {
    updateField, //vuex-map-fields
    removeFromState(state, data) {
      let items = [];
      Object.entries(state[data.name]).forEach(item => {
        if (Number(item[1].id) != Number(data.id)) {
          items.push(item[1]);
        }
      });
      Vue.set(state, data.name, items);
    },
  },
  actions: {
    async calculationShow({commit, state, dispatch}, payload) {
      updateField(state, {path: 'calculationIsLoading', value: true});
      return axios.get(this._vm.$apiURL + '/calculation/' + payload.id)
        .then((response) => {
          updateField(state, {path: 'calculation', value: response.data});
        })
        .catch((error) => {
          dispatch('common/showError', {'error': error}, {root: true});
        })
        .finally(() => {
          updateField(state, {path: 'calculationIsLoading', value: false});
        })
    },
    async getCalculations({commit, state, dispatch}) {
      updateField(state, {path: 'calculationIsLoading', value: true});
      return axios.get(this._vm.$apiURL + '/calculations')
        .then((response) => {
          updateField(state, {path: 'calculations', value: response.data.calculations});
        })
        .catch((error) => {
          dispatch('common/showError', {'error': error}, {root: true});
        })
        .finally(() => {
          updateField(state, {path: 'calculationIsLoading', value: false});
        })
    },
    async getCarts({commit, state, dispatch}) {
      updateField(state, {path: 'cartIsLoading', value: true});
      return axios.get(this._vm.$apiURL + '/carts')
        .then((response) => {
          if (response.data.carts) {
            updateField(state, {path: 'defaultCartId', value: response.data.defaultCartId});
            updateField(state, {path: 'carts', value: response.data.carts});
            let cartCount = 0;
            let items = state.carts.filter(cart => state.defaultCartId === cart.id)[0].items;
            if (items.length > 0) {
              for (let i in items) {
                cartCount += items[i]['amount'];
              }
            }
            updateField(state, {path: 'defaultCartCounter', value: cartCount});
          }
          updateField(state, {path: 'cartIsLoading', value: false});
        })
        .catch((error) => {
          dispatch('common/showError', {'error': error}, {root: true});
          updateField(state, {path: 'cartIsLoading', value: false});
        })
    },
    removeActiveCart({commit, state, dispatch}, payload) {
      this._vm.$confirm({
        title: this._vm.i18n.t('common.confirm'),
        text: this._vm.i18n.t('common.confirm_remove'),
        cancelText: this._vm.i18n.t('common.no'),
        acceptText: this._vm.i18n.t('common.yes')
      }).then(y => {
        return axios.delete(this._vm.$apiURL + '/cart')
          .then(response => {
            if (response.data.status === 'success') {
              dispatch('getCarts');
              this._vm.$inform(this._vm.i18n.t('common.success_remove'))
            }
          })
          .catch(error => {
            dispatch('common/showError', {'error': error}, {root: true});
          });
      }).catch(n => {
      });
    },
    renameDefaultCart({commit, state, dispatch}, payload) {
      return axios.post(this._vm.$apiURL + '/cart/renameDefault', {name: payload.name})
        .then(response => {
          if (response.data.status === 'success') {
            dispatch('getCarts');
            this._vm.$inform(this._vm.i18n.t('common.operation_success'))
          }
        })
        .catch(error => {
          dispatch('common/showError', {'error': error}, {root: true});
        });
    },
    async createCart({commit, state, dispatch}, payload) {
      updateField(state, {path: 'cartIsLoading', value: true});
      return await axios.post(this._vm.$apiURL + '/carts', payload)
        .then((response) => {
          dispatch('getCarts');
          return true;
        })
        .catch((error) => {
          dispatch('common/showError', {'error': error}, {root: true});
          updateField(state, {path: 'cartIsLoading', value: false});
          return false;
        })
    },
    async setDefaultCart({commit, state, dispatch}, payload) {
      return await axios.post(this._vm.$apiURL + '/cart/setDefaultCart', {id: payload})
        .then((response) => {
          updateField(state, {path: 'defaultCartId', value: payload});
          return;
        })
        .catch((error) => {
          dispatch('common/showError', {'error': error}, {root: true});
        })
        .finally(() => {
          dispatch('getCarts');
        })
    },
    cartItemUpdate({commit, state, dispatch}, payload) {
      return axios.put(this._vm.$apiURL + '/carts/' + payload.id + '/items/' + payload.item.id, payload.item)
        .then((response) => {
          this._vm.$inform(this._vm.i18n.t('common.operation_success'))
        })
        .catch((error) => {
          dispatch('common/showError', {'error': error}, {root: true});
        })
        .finally(() => {
          dispatch('getCarts');
        })
    },
    updateCart({commit, state, dispatch}, cart) {
      return axios.put(this._vm.$apiURL + '/carts/' + cart.id, {cart})
        .then((response) => {
          //updateField(state, {path:'defaultCartId', value: payload});
        })
        .catch((error) => {
          dispatch('common/showError', {'error': error}, {root: true});
        })
        .finally(() => {
          dispatch('getCarts');
        })
    },
    cartCheckResult({commit, state, dispatch}, payload) {
      return axios.post(this._vm.$apiURL + '/cart/' + payload.id + '/check-result')
        .then((response) => {
          return response.data;
        })
        .catch((error) => {
          console.log('cartCheckResult=', error)
          //dispatch('common/showError', {'error': error}, {root:true});
        })
        .finally(() => {
          //updateField(state, {path: 'cartCheckLoading', value: false});
        })
    },
    cartCheck({commit, state, dispatch}, payload) {
      updateField(state, {path: 'cartCheckLoading', value: true});
      return axios.post(this._vm.$apiURL + '/cart/' + payload.id + '/check')
        .then((response) => {
          return response.data;
        })
        .catch((error) => {
          console.log('cartCheck=', error)
          //dispatch('common/showError', {'error': error}, {root: true});
        })
        .finally(() => {
          updateField(state, {path: 'cartCheckLoading', value: false});
        })
    },
    transformCartToCalculation({commit, state, dispatch}, cart) {
      updateField(state, {path: 'cartIsLoading', value: true});
      return axios.post(this._vm.$apiURL + '/cart/' + cart.id + '/transform-to-calculation', cart)
        .then((response) => {
          return response.data;
        })
        .catch((error) => {
          dispatch('common/showError', {'error': error}, {root: true});
        })
        .finally(() => {
          updateField(state, {path: 'cartIsLoading', value: false});
          dispatch('getCarts');
        })
    },
    transformCalculationToCart({commit, state, dispatch}, calculation) {
      updateField(state, {path: 'cartIsLoading', value: true});
      return axios.post(this._vm.$apiURL + '/cart/' + calculation.id + '/transform-to-cart', calculation)
        .then((response) => {
          return response.data;
        })
        .catch((error) => {
          dispatch('common/showError', {'error': error}, {root: true});
        })
        .finally(() => {
          updateField(state, {path: 'cartIsLoading', value: false});
          dispatch('getCarts');
        })
    },
    async addToCart({commit, state, dispatch}, payload) {
      updateField(state, {path: 'cartIsLoading', value: true});
      return await axios.post(this._vm.$apiURL + '/cart/insert', payload)
        .then((response) => {
          return response.data;
        })
        .catch((error) => {
          dispatch('common/showError', {'error': error}, {root: true});
        })
        .finally(() => {
          updateField(state, {path: 'cartIsLoading', value: false});
          dispatch('getCarts');
        })
    },
    removeFromCart({commit, state, dispatch}, payload) {
      updateField(state, {path: 'cartIsLoading', value: true});
      return axios.post(this._vm.$apiURL + '/cart/removeFrom', payload)
        .then((response) => {
          return response.data;
        })
        .catch((error) => {
          dispatch('common/showError', {'error': error}, {root: true});
        })
        .finally(() => {
          updateField(state, {path: 'cartIsLoading', value: false});
          dispatch('getCarts');
          dispatch('getCalculations');
        })
    },
  }
}
